import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  language: Cookies.get("language") || "zh",
  size: Cookies.get('size') || 'medium',
  screen:{
    width:0,
    height:0
  },
  dialogStatus:2,
  fullScreenShowSvg: {
    isShow: false,
    svgStr: "",
    bgColor: ""
  },
}

const mutations = {
  SET_DIALOGSTAT:(state,type) => {
    state.dialogStatus = type;
  },
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language
    Cookies.set('language', language)
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  SET_SCREEN:(state,{width,height})=>{
    state.screen.width = width;
    state.screen.height = height;
  },
  SET_FULLSHOWSVG: (state, data) => {
    let par = JSON.parse(JSON.stringify(data));
    if (!data.svgStr || data.svgStr.includes("暂无数据")) {
      par.isShow = false;
    }
    state.fullScreenShowSvg = par;
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  setScreen({ commit }, {width,height}){

    commit('SET_SCREEN', {width,height})
  },
  setFullShow({ commit }, data) {
    commit('SET_FULLSHOWSVG', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
